var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilletera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-bills-24-outlined"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.3751 17.7083C74.3751 13.7963 71.2038 10.625 67.2918 10.625H17.7084C13.7964 10.625 10.6251 13.7963 10.6251 17.7083H74.3751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6668 46.0417C56.6668 38.2176 50.3241 31.875 42.5001 31.875C34.6761 31.875 28.3334 38.2176 28.3334 46.0417C28.3334 53.8657 34.6761 60.2083 42.5001 60.2083C50.3241 60.2083 56.6668 53.8657 56.6668 46.0417ZM42.5001 38.9583C38.5881 38.9583 35.4168 42.1297 35.4168 46.0417C35.4168 49.9537 38.5881 53.125 42.5001 53.125C46.4121 53.125 49.5834 49.9537 49.5834 46.0417C49.5834 42.1297 46.4121 38.9583 42.5001 38.9583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8334 46.0417C70.8334 44.0857 69.2478 42.5 67.2918 42.5C65.3357 42.5 63.7501 44.0857 63.7501 46.0417C63.7501 47.9977 65.3357 49.5833 67.2918 49.5833C69.2478 49.5833 70.8334 47.9977 70.8334 46.0417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7084 42.5C19.6644 42.5 21.2501 44.0857 21.2501 46.0417C21.2501 47.9977 19.6644 49.5833 17.7084 49.5833C15.7524 49.5833 14.1667 47.9977 14.1667 46.0417C14.1667 44.0857 15.7524 42.5 17.7084 42.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.019 21.25C78.5754 21.25 81.4584 24.4213 81.4584 28.3333V63.75C81.4584 67.662 78.5754 70.8333 75.019 70.8333H9.98114C6.42476 70.8333 3.54175 67.662 3.54175 63.75V28.3333C3.54175 24.4213 6.42476 21.25 9.98114 21.25H75.019ZM74.3751 28.3333H10.6251V63.75H74.3751V28.3333Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilletera);
export default __webpack_public_path__ + "static/media/billetera.894491b8610b8fa79544044a035e581f.svg";
export { ForwardRef as ReactComponent };